import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import css from "../../assets/css/Addcase.module.css";
import Compressor from "compressorjs";
import "../../assets/css/Loader.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/css/viewGame.css";
import "../../assets/css/layout.css";
import Swal from "sweetalert2";
import "../../assets/css/landing.css";
import Modal from "react-bootstrap/Modal";
import { BsArrowLeft, BsArrowRight, BsQrCodeScan } from "react-icons/bs";
import { RiQrCodeLine } from "react-icons/ri";
import { FaUniversity, FaWhatsapp } from "react-icons/fa";
import { MdContentCopy } from "react-icons/md";
import AppLoader from "../Components/AppLoader";
import { apiRequest } from "../../apiService/allApi";

const Addcase = ({ walletUpdate }) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const history = useHistory();

  const [userAllData, setUserAllData] = useState();

  const [isLoading1, setIsloading1] = useState(false);
  const [global, setGlobal] = useState(100);
  const [next, setNext] = useState(1);
  const [process1, setProcess] = useState(false);

  const [payinOne, setPayinOne] = useState(false);
  const [isUpiGateway, setUpiGateway] = useState(false);
  const [isUpiGateway02, setUpiGateway02] = useState(false);
  const [isWhatsappDeposit, setwhatsappDeposit] = useState(false);

  const [gatewayData, setGatewayData] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [copiedField, setCopiedField] = useState("");

  const [show_won, setShow_won] = useState(false);
  const handleClose_won = () => setShow_won(false);
  const [scrnshot, setScrnshot] = useState(null);
  const [scrnshot1, setScrnshot1] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [minLimit, setMinLimit] = useState(null);
  const [maxLimit, setMaxLimit] = useState(null);
  const [utr, setutr] = useState("");

  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  useEffect(() => {
    setMinLimit(addCaseSetting.depositlimitMin);
    setMaxLimit(addCaseSetting.depositlimitMax);

    if (!addCaseSetting.isDeposit) {
      <script>
        document.getElementById("addcase").style.display = "none";
        document.getElementById("depositClose").style.display = "block";
      </script>;
    }
  }, []);

  const handleNext = () => {
    if (global < minLimit || global > maxLimit) {
      Swal.fire({
        title: `Minimum amount should be greater than ${minLimit} and maximum amount should be less than ${maxLimit}`,

        confirmButtonText: "OK",
        content: "custom-swal-content",
      });
    } else {
      setNext(2);
    }
  };

  const upigateway = async () => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const respone = await apiRequest(
      `upigateway/payin?amount=${global.toFixed(2)}`,
      "POST",
      { amount: global },
      headers,
    );

    if (respone.data.data.status) {
      window.open(respone.data.data.data.payment_url);
    } else {
      setProcess(false);
      Swal.fire({
        title: respone.data.data.msg,
        icon: "danger",
        confirmButtonText: "OK",
      });
    }
  };

  const upigateway02 = async () => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const respone = await apiRequest(
      `upigateway/payin2?amount=${global.toFixed(2)}`,
      "POST",
      { amount: global },
      headers,
    );

    if (respone.data.data.status) {
      window.open(respone.data.data.data.payment_url);
    } else {
      setProcess(false);
      Swal.fire({
        title: respone.data.data.msg,
        icon: "danger",
        confirmButtonText: "OK",
      });
    }
  };

  const imbGateway = async () => {
    setProcess(true);
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const response = await apiRequest(
        "imb/payin",
        "POST",
        { amount: global },
        headers,
      );

      console.log("IMB payin response:", response?.data);
      const gatewayResponse = response?.data?.data;

      if (gatewayResponse?.status) {
        window.open(
          gatewayResponse?.result?.payment_url,
          "_blank",
          "noopener,noreferrer",
        );
      } else {
        Swal.fire({
          title: gatewayResponse?.data?.data?.message || "Payment gateway error.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("IMB payin request failed:");
      Swal.fire({
        title: error?.response?.data?.data?.message || "Payment request failed.",
        icon: "error",
        confirmButtonText: "OK",
      });
    } finally {
      setProcess(false);
    }
  };

  const meApi = async () => {
    let access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const respone = await apiRequest("me", "GET", null, headers);

      setUserAllData(respone.data);
    } catch (e) {}
  };
  useEffect(() => {
    meApi();
  }, []);

  const clearImage = (e) => {
    setScrnshot1(null);
    setScrnshot(null);
  };

  const handleChange = (e) => {
    setScrnshot1(URL.createObjectURL(e.target.files[0]));
    const image = e.target.files[0];
    if (image && image.size / 1000 > 300) {
      new Compressor(image, {
        quality: 0.6,
        success(compressedResult) {
          if (compressedResult) {
            setScrnshot(compressedResult);
          } else {
            setScrnshot(image);
          }
        },
      });
    } else {
      setScrnshot(e.target.files[0]);
    }
  };

  const ManualPayment = async () => {
    const access_token = localStorage.getItem("token");
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${access_token}`);

    try {
      const result = await apiRequest(
        "gatewaysettings/data",
        "GET",
        null,
        myHeaders,
      );
      setGatewayData(result.data);
      setPayinOne(result?.data?.payinOne);
      setUpiGateway(result?.data?.isUpiGateway);
      setUpiGateway02(result?.data?.isUpiGateway02);
      setwhatsappDeposit(result?.data?.whatsappDeposit);
    } catch (error) {}
  };

  useEffect(() => {
    ManualPayment();
  }, []);

  const fetchBanks = async () => {
    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    try {
      const result = await apiRequest("get/allbank", "GET", null, headers);
      const list = result?.data?.data;
      setBankList(Array.isArray(list) ? list : []);
    } catch (error) {
      setBankList([]);
    }
  };

  useEffect(() => {
    fetchBanks();
  }, []);

  const visibleBanks = bankList.filter((item) => {
    if (!item || item.deleted) return false;
    return (
      Boolean(item.status) && global >= item.minLimit && global <= item.maxLimit
    );
  });

  const mediaUrl = (path) => {
    if (!path) return "";
    if (String(path).startsWith("http")) return path;
    const base = String(baseUrl || "").replace(/\/$/, "");
    return `${base}/${String(path).replace(/^\//, "")}`;
  };

  const copyValue = async (key, value) => {
    if (!value) return;
    const text = String(value);
    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      const input = document.createElement("textarea");
      input.value = text;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
    }
    setCopiedField(key);
    setTimeout(() => setCopiedField(""), 1400);
  };

  const openBank = (bank) => {
    setSelectedBank(bank);
    setNext(4);
  };

  const openWhatsappChat = () => {
    const digits = String(gatewayData?.whatsappDepositNo || "").replace(
      /[^\d]/g,
      "",
    );
    if (!digits) return;
    const preset = addCaseSetting?.whatsappDepositmsg;
    const text = preset
      ? `${preset}\nAmount: ₹${global}`
      : `Hello, I want to deposit ₹${global}.`;
    window.open(
      `https://wa.me/${digits}?text=${encodeURIComponent(text)}`,
      "_blank",
    );
  };

  const ManualPayments = async () => {
    setIsloading1(true);
    var formdata = new FormData();
    formdata.append("Transaction_Screenshot", scrnshot);
    formdata.append("amount", global);
    formdata.append("referenceId", utr);

    const access_token = localStorage.getItem("token");
    const headers = {
      Authorization: `Bearer ${access_token}`,
    };

    const result = await apiRequest(
      "manual/deposit/txn",
      "POST",
      formdata,
      headers,
    );
    setIsloading1(false);

    if (result?.data?.status === "Pending") {
      Swal.fire({
        title: result?.data?.message,
        icon: "success",
        confirmButtonText: "OK",
      });
    } else {
      Swal.fire({
        title: result?.data?.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
    history.push("/");
    handleClose_won();
  };

  return (
    <>
      <div className="leftContainer position-relative page_layout">
        <div className="Orher_page_main_section">
          {Boolean(!process1) && (
            <div>
              {Boolean(next == 1) && (
                <div className="profile_box">
                  <div className="d-flex align-items-center justify-content-center">
                    <h2 className="profile_headings mb-0">
                      Choose Amount To Add
                    </h2>
                  </div>

                  <div className="arcade-deposit-wrapper">
                    <div className="arcade-card">
                      <div className="arcade-header">
                        <h3 className="arcade-title">Enter Amount</h3>
                        <div className="status-dot-pulse"></div>
                      </div>

                      <div className="arcade-input-container">
                        <div className="arcade-input-row">
                          <div className="currency-glow-box">
                            <img src="/images/rupee.png" alt="₹" />
                          </div>
                          <input
                            className="arcade-numeric-input"
                            type="tel"
                            id="amountInput"
                            placeholder="Enter Amount"
                            value={global}
                            onChange={(e) => {
                              e.target.value > 0
                                ? e.target.value <= 50000
                                  ? setGlobal(parseInt(e.target.value))
                                  : setGlobal(50000)
                                : e.target.value < 0
                                  ? setGlobal(10)
                                  : setGlobal(0);
                            }}
                          />
                        </div>
                      </div>

                      <div className="arcade-btn-grid">
                        {[100, 250, 500, 2000].map((amt) => (
                          <button
                            key={amt}
                            className="glass-chip"
                            onClick={() => setGlobal(amt)}
                          >
                            <div className="chip-content">
                              <img
                                src="/images/Coin without Glow.gif"
                                alt="coin"
                                className="coin-gif-small"
                              />
                              <span>{amt}</span>
                            </div>
                          </button>
                        ))}
                      </div>

                      <div className="arcade-footer">
                        {addCaseSetting.isDeposit ? (
                          <button
                            type="button"
                            id="addcase"
                            className="neo-deposit-btn"
                            onClick={handleNext}
                          >
                            <span>Next</span>
                            <div className="btn-glow"></div>
                            <BsArrowRight className="btn-icon-move" />
                          </button>
                        ) : (
                          <div className="arcade-notice-box" id="depositClose">
                            <p>⚠️ Deposit services Close for some time</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {Boolean(next === 2) && (
                <div className="">
                  <>
                    <div className="pb-3">
                      <div className={`${css.games_section}`}>
                        <div className="d-flex position-relative align-items-center justify-content-between">
                          <div className="add_cash_small_haedings">
                            Amount to be added
                            <span className="ml-1">₹</span>
                            <b>{global}</b>
                          </div>
                          <button
                            type="button"
                            onClick={() => setNext(1)}
                            className="badge-light-primary"
                            style={{
                              border: "none",
                              cursor: "pointer",
                              padding: "6px 14px",
                            }}
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="mt-4">
                      <div className="profile_headings mb-3">
                        Pay Through QR CODE
                      </div>

                      <div className={css.methodList}>
                        {Boolean(isUpiGateway) &&
                        global >= gatewayData?.upiGatewayMin &&
                        global <= gatewayData?.upiGatewayMax ? (
                          <div
                            onClick={() => upigateway()}
                            className={css.paymentMethodCard}
                          >
                            {isLoading ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "20px 0",
                                  width: "100%",
                                }}
                              >
                                <AppLoader size="sm" color="primary" />
                              </div>
                            ) : (
                              <>
                                <div
                                  className={`${css.paymentIconBox} ${css.iconBoxQr1}`}
                                >
                                  <BsQrCodeScan size={24} />
                                </div>
                                <div className={css.paymentMeta}>
                                  <div className={css.paymentTitle}>
                                    Pay Qr Code
                                  </div>
                                  <div className={css.paymentSubtitle}>
                                    Instant QR Scan • All UPI Apps
                                  </div>
                                </div>
                                <div className={css.paymentRightSide}>
                                  <BsArrowRight className={css.paymentArrow} />
                                </div>
                              </>
                            )}
                          </div>
                        ) : null}

                        {Boolean(isUpiGateway02) &&
                        global >= gatewayData?.upiGatewayMin2 &&
                        global <= gatewayData?.upiGatewayMax2 ? (
                          <div
                            onClick={() => upigateway02()}
                            className={css.paymentMethodCard}
                          >
                            {isLoading ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "20px 0",
                                  width: "100%",
                                }}
                              >
                                <AppLoader size="sm" color="primary" />
                              </div>
                            ) : (
                              <>
                                <div
                                  className={`${css.paymentIconBox} ${css.iconBoxQr2}`}
                                >
                                  <RiQrCodeLine size={26} />
                                </div>
                                <div className={css.paymentMeta}>
                                  <div className={css.paymentTitle}>
                                    Pay Qr Code 2
                                  </div>
                                  <div className={css.paymentSubtitle}>
                                    Alternative QR Gateway • Auto Credit
                                  </div>
                                </div>
                                <div className={css.paymentRightSide}>
                                  <BsArrowRight className={css.paymentArrow} />
                                </div>
                              </>
                            )}
                          </div>
                        ) : null}

                        {Boolean(payinOne) &&
                        global >= gatewayData?.payinMin &&
                        global <= gatewayData?.payinMax ? (
                          <div
                            onClick={() => imbGateway()}
                            className={css.paymentMethodCard}
                          >
                            {isLoading ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "20px 0",
                                  width: "100%",
                                }}
                              >
                                <AppLoader size="sm" color="primary" />
                              </div>
                            ) : (
                              <>
                                <div
                                  className={`${css.paymentIconBox} ${css.iconBoxQr2}`}
                                >
                                  <RiQrCodeLine size={26} />
                                </div>
                                <div className={css.paymentMeta}>
                                  <div className={css.paymentTitle}>
                                    Pay Gateway
                                  </div>
                                  <div className={css.paymentSubtitle}>
                                    Alternative QR Gateway • Auto Credit
                                  </div>
                                </div>
                                <div className={css.paymentRightSide}>
                                  <BsArrowRight className={css.paymentArrow} />
                                </div>
                              </>
                            )}
                          </div>
                        ) : null}

                        {Boolean(isWhatsappDeposit) &&
                        global >= gatewayData?.whatsappRangemin &&
                        global <= gatewayData?.whatsappRangemax ? (
                          <div
                            onClick={() => setNext(3)}
                            className={css.paymentMethodCard}
                          >
                            {isLoading ? (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  padding: "20px 0",
                                  width: "100%",
                                }}
                              >
                                <AppLoader size="sm" color="primary" />
                              </div>
                            ) : (
                              <>
                                <div
                                  className={`${css.paymentIconBox} ${css.iconBoxWa}`}
                                >
                                  <FaWhatsapp size={26} />
                                </div>
                                <div className={css.paymentMeta}>
                                  <div className={css.paymentTitle}>
                                    Pay with WhatsApp
                                  </div>
                                  <div className={css.paymentSubtitle}>
                                    24x7 Direct Chat &amp; Manual Verification
                                  </div>
                                </div>
                                <div className={css.paymentRightSide}>
                                  <BsArrowRight className={css.paymentArrow} />
                                </div>
                              </>
                            )}
                          </div>
                        ) : null}

                        {visibleBanks.length > 0
                          ? visibleBanks.map((item) => {
                              const hasQrCode = Boolean(item.qrcodeImage);
                              const hasBankName = Boolean(
                                item.bankName?.trim(),
                              );
                              const hasUpiId = Boolean(item.upiId?.trim());
                              const paymentTitle = hasQrCode
                                ? "Pay With QR Code"
                                : hasBankName
                                  ? `Pay With ${item.bankName}`
                                  : hasUpiId
                                    ? "Pay With UPI ID"
                                    : "Pay With Bank Transfer";
                              const paymentSubtitle = hasQrCode
                                ? "Scan QR code to pay"
                                : hasUpiId && !hasBankName
                                  ? "Pay directly using UPI ID"
                                  : "Direct Transfer • IMPS / NEFT";

                              return (
                                <div
                                  key={item._id}
                                  className={css.paymentMethodCard}
                                  onClick={() => openBank(item)}
                                >
                                  <div
                                    className={`${css.paymentIconBox} ${css.iconBoxBank}`}
                                  >
                                    <FaUniversity size={22} />
                                  </div>
                                  <div className={css.paymentMeta}>
                                    <div className={css.paymentTitle}>
                                      {paymentTitle}
                                    </div>
                                    <div className={css.paymentSubtitle}>
                                      {paymentSubtitle}
                                    </div>
                                  </div>
                                  <div className={css.paymentRightSide}>
                                    <BsArrowRight
                                      className={css.paymentArrow}
                                    />
                                  </div>
                                </div>
                              );
                            })
                          : null}
                      </div>
                    </div>
                  </>
                </div>
              )}

              {Boolean(next === 3) && (
                <div>
                  <div className="pb-3">
                    <div className={`${css.games_section}`}>
                      <div className="d-flex position-relative align-items-center justify-content-between">
                        <button
                          type="button"
                          className={css.backBtn}
                          onClick={() => setNext(2)}
                        >
                          <BsArrowLeft />
                          Back
                        </button>
                        <div className="add_cash_small_haedings">
                          Amount
                          <span className="ml-1">₹</span>
                          <b>{global}</b>
                        </div>
                        <button
                          type="button"
                          onClick={() => setNext(1)}
                          className="badge-light-primary"
                          style={{
                            border: "none",
                            cursor: "pointer",
                            padding: "6px 14px",
                          }}
                        >
                          Edit
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className={css.waCard}>
                    <div className={css.waBadge}>
                      <FaWhatsapp />
                    </div>
                    <h3 className={css.waTitle}>Pay with WhatsApp</h3>
                    <p className={css.waText}>
                      Send ₹{global} on this number and share your payment
                      screenshot in the chat.
                    </p>

                    <div className={css.waNumberBox}>
                      <span>WhatsApp Number</span>
                      <strong>
                        {gatewayData?.whatsappDepositNo || "Not available"}
                      </strong>
                    </div>

                    <div className={css.waActions}>
                      <button
                        type="button"
                        className={css.copyBtn}
                        onClick={() =>
                          copyValue("whatsapp", gatewayData?.whatsappDepositNo)
                        }
                        disabled={!gatewayData?.whatsappDepositNo}
                      >
                        <MdContentCopy />
                        {copiedField === "whatsapp" ? "Copied" : "Copy Number"}
                      </button>
                      <button
                        type="button"
                        className={css.waBtn}
                        onClick={openWhatsappChat}
                        disabled={!gatewayData?.whatsappDepositNo}
                      >
                        <FaWhatsapp />
                        Open WhatsApp Chat
                      </button>
                    </div>

                    {addCaseSetting?.whatsappDepositmsg ? (
                      <div className={css.waMessage}>
                        {addCaseSetting.whatsappDepositmsg}
                      </div>
                    ) : null}

                    <ol className={css.stepList}>
                      <li>Open the WhatsApp chat for this number.</li>
                      <li>Send the exact amount ₹{global}.</li>
                      <li>Share the payment screenshot in the same chat.</li>
                      <li>Wallet updates after the payment is confirmed.</li>
                    </ol>
                  </div>
                </div>
              )}

              {Boolean(next === 4) && (
                <div>
                  <div className="pb-3">
                    <div className={`${css.games_section}`}>
                      <div className="d-flex position-relative align-items-center justify-content-between">
                        <button
                          type="button"
                          className={css.backBtn}
                          onClick={() => setNext(2)}
                        >
                          <BsArrowLeft />
                          Back
                        </button>
                        <div className="add_cash_small_haedings">
                          Amount
                          <span className="ml-2">₹</span>
                          <b>{global}</b>
                        </div>
                        <button
                          type="button"
                          onClick={() => setNext(1)}
                          className="badge-light-primary"
                          style={{
                            border: "none",
                            cursor: "pointer",
                            padding: "6px 14px",
                          }}
                        >
                          Edit
                        </button>
                      </div>
                    </div>
                  </div>

                  {selectedBank ? (
                    <div className={css.detailCard}>
                      <div className={css.detailHead}>
                        <div className={css.bankIcon}>
                          <FaUniversity />
                        </div>
                        <div>
                          <div className={css.bankTitle}>
                            {selectedBank.bankName || "Bank Account"}
                          </div>
                          <div className={css.bankSub}>
                            Transfer exactly ₹{global}
                          </div>
                        </div>
                      </div>

                      {[
                        {
                          key: "accountHolderName",
                          label: "Account Holder",
                          value: selectedBank.accountHolderName,
                        },
                        {
                          key: "accountNumber",
                          label: "Account Number",
                          value: selectedBank.accountNumber,
                          copy: true,
                        },
                        {
                          key: "ifscCode",
                          label: "IFSC Code",
                          value: selectedBank.ifscCode,
                          copy: true,
                        },
                        {
                          key: "upiHolderName",
                          label: "UPI Name",
                          value: selectedBank.upiHolderName,
                        },
                        {
                          key: "upiId",
                          label: "UPI ID",
                          value: selectedBank.upiId,
                          copy: true,
                        },
                      ]
                        .filter((row) => row.value)
                        .map((row) => (
                          <div className={css.detailRow} key={row.key}>
                            <div>
                              <span>{row.label}</span>
                              <strong>{row.value}</strong>
                            </div>
                            {row.copy ? (
                              <button
                                type="button"
                                className={css.iconCopy}
                                aria-label={
                                  copiedField === row.key
                                    ? `${row.label} copied`
                                    : `Copy ${row.label}`
                                }
                                onClick={() => copyValue(row.key, row.value)}
                              >
                                {copiedField === row.key ? (
                                  "Copied"
                                ) : (
                                  <MdContentCopy />
                                )}
                              </button>
                            ) : null}
                          </div>
                        ))}

                      {selectedBank.qrcodeImage ? (
                        <div className={css.qrBox}>
                          <span>Scan QR</span>
                          <img
                            src={mediaUrl(selectedBank.qrcodeImage)}
                            alt="Payment QR"
                          />
                        </div>
                      ) : null}

                      <button
                        type="button"
                        className={css.submitPay}
                        onClick={() => setShow_won(true)}
                      >
                        I Have Paid
                      </button>
                    </div>
                  ) : (
                    <div className={css.emptyNote}>
                      Select a bank account to see payment details.
                    </div>
                  )}
                </div>
              )}
            </div>
          )}

          {Boolean(process1) && <AppLoader fullScreen text="Processing..." />}
        </div>
      </div>

      <section className="win_modal">
        <Modal
          show={show_won}
          onHide={handleClose_won}
          className="cancel_popup_reason_popup payments_popup upload_result"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <h3 className="modal-title font-weight-bold">Payment Details</h3>
          </Modal.Header>
          <Modal.Body className="pt-2">
            <div className="upload-wrapper-stack">
              <div className="w-100 text-left mb-2">
                <label className="commaon_label">Deposit Amount</label>
                <div className="position-relative">
                  <input
                    className="commaon_input_box"
                    type="number"
                    required
                    value={global}
                    onChange={(e) => setGlobal(e.target.value)}
                    placeholder="Enter amount"
                    readOnly
                  />
                </div>
              </div>

              <div className="w-100 text-left mb-">
                <label className="commaon_label">UTR / Reference Number</label>
                <input
                  className="commaon_input_box"
                  type="text"
                  required
                  value={utr}
                  onChange={(e) => setutr(e.target.value)}
                  placeholder="Enter 12-digit UTR Number"
                />
              </div>

              <div className="w-100 text-left mb-2">
                <label className="commaon_label">Payment Screenshot</label>
                <div className="upload-interactive-card">
                  <input
                    type="file"
                    onChange={handleChange}
                    accept="image/*"
                    required
                    className="input-overlay-hidden"
                  />

                  {!scrnshot ? (
                    <div className="drag-content">
                      <div className="add-circle">+</div>
                      <p>Add Payment Screenshot</p>
                    </div>
                  ) : (
                    <div className="success-file-badge">
                      <div className="badge-left">
                        <div className="file-preview-mini">
                          <img src="/images/file-icon.png" alt="icon" />
                        </div>
                        <div className="file-meta-data">
                          <p className="m-0 truncate-text">{scrnshot.name}</p>
                          <small>
                            {(scrnshot.size / 1024 / 1024).toFixed(2)} MB
                          </small>
                        </div>
                      </div>
                      <button
                        className="clear-btn-minimal"
                        type="button"
                        onClick={() => {
                          clearImage();
                        }}
                      >
                        x
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {Boolean(scrnshot1) && (
                <div className="uploaded-image-preview-container mb-3">
                  <img
                    src={scrnshot1}
                    alt="Payment screenshot"
                    className="uploaded-image-preview"
                  />
                </div>
              )}

              <div className="button-stack-area w-100 mt-2">
                {isLoading1 ? (
                  <button
                    className="submit-glass-btn btn-active d-flex align-items-center justify-content-center"
                    disabled
                  >
                    <AppLoader size="sm" color="white" className="mr-2" />
                    Submitting...
                  </button>
                ) : (
                  <button
                    type="button"
                    className={`submit-glass-btn ${
                      !utr || !scrnshot ? "btn-locked" : "btn-active"
                    }`}
                    id="post"
                    onClick={ManualPayments}
                    disabled={!utr || !scrnshot}
                  >
                    {!utr || !scrnshot
                      ? "Enter UTR & Screenshot First"
                      : "Submit Payment"}
                  </button>
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </section>
    </>
  );
};

export default Addcase;
